export enum TalentType {
  W2 = 'W2',
  _1099 = '1099'
}
